import { Aggregate, APIFieldType } from '@ardoq/api-types';
import { type I18nLocale, t } from '@ardoq/i18n';

export const NUMBER_OF_ROWS_PER_PAGE = 25;
export const COPY_ARDOQ_REPORT_LABEL = 'Copy Ardoq report URL';
export const COPY_DISCOVER_REPORT_LABEL = 'Copy Discover report URL';
export const COPY_REPORT_LABEL = 'Copy report URL';
export const aggregates = Object.values(Aggregate);

export const FILTERS_URL_KEY = 'filters';
export const REFERRER_URL_KEY = 'referrer';
export const VIEW_STATE_URL_KEY = 'state';

export const FILTERS_STORAGE_KEY = 'reportFilters';

export const aggregatesWithLabel: Record<Aggregate, string> = {
  [Aggregate.MIN]: 'Minimum',
  [Aggregate.MAX]: 'Maximum',
  [Aggregate.AVERAGE]: 'Average (including not set values)',
  [Aggregate.AVERAGE_SET]: 'Average (only set values)',
  [Aggregate.SUM]: 'Sum',
  [Aggregate.COUNT]: 'Count',
  // [Aggregate.COUNT_NOT_SET]: 'Count (only not set values)',
  // [Aggregate.COUNT_SET]: 'Count (only set values)',
  [Aggregate.MEDIAN]: 'Median',
};

export const getAggregateLabels = (
  i18nLocale: I18nLocale
): Record<Aggregate, string> => ({
  [Aggregate.MIN]: t(i18nLocale, 'reportReader:aggregate.min', 'Minimum'),
  [Aggregate.MAX]: t(i18nLocale, 'reportReader:aggregate.max', 'Maximum'),
  [Aggregate.AVERAGE]: t(
    i18nLocale,
    'reportReader:aggregate.average',
    'Average (including not set values)'
  ),
  [Aggregate.AVERAGE_SET]: t(
    i18nLocale,
    'reportReader:aggregate.averageSet',
    'Average (only set values)'
  ),
  [Aggregate.SUM]: t(i18nLocale, 'reportReader:aggregate.sum', 'Sum'),
  [Aggregate.COUNT]: t(i18nLocale, 'reportReader:aggregate.count', 'Count'),
  [Aggregate.MEDIAN]: t(i18nLocale, 'reportReader:aggregate.median', 'Median'),
});

export const REPORT_DEFAULT_FIELDS = [
  { name: 'createdBy', label: 'Created by', type: APIFieldType.USER },
  { name: 'lastModifiedBy', label: 'Last updated by', type: APIFieldType.USER },
  {
    name: 'parent',
    label: 'Parent Component',
    type: APIFieldType.TEXT,
  },
  {
    name: 'source',
    label: 'Source Component',
    type: APIFieldType.TEXT,
  },
  {
    name: 'target',
    label: 'Target Component',
    type: APIFieldType.TEXT,
  },
  {
    name: 'lastUpdated',
    label: 'Updated at',
    type: APIFieldType.DATE_TIME,
  },
  {
    name: 'created',
    label: 'Created at',
    type: APIFieldType.DATE_TIME,
  },
  {
    name: '_id',
    label: 'Ardoq OID',
    type: APIFieldType.TEXT,
  },
  {
    name: 'component-key',
    label: 'Ardoq ID',
    type: APIFieldType.TEXT,
  },
  {
    name: 'type',
    label: 'Type',
    type: APIFieldType.TEXT,
  },
  {
    name: 'name',
    label: 'Name',
    type: APIFieldType.TEXT,
  },
  {
    name: 'displayText',
    label: 'Display text',
    type: APIFieldType.TEXT,
  },
  {
    name: 'description',
    label: 'Description',
    type: APIFieldType.TEXT_AREA,
  },
];
